<template>
  <div>
    <section class="base-header-sec base-header-laen  laen">
      <div class="base-header__top-line laen"></div>
      <div class="container-fluid">
        <div class="   base-header__container ">
          <div class="  d-flex justify-content-center align-items-center">
            <h1 class="base-header__title text-center py-2">
              <!--                            <span class="base-header__icon icon-inbox mr-3"></span>-->
              Календар догађаја
            </h1>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid base-container">
      <div class="base-box base-box__table-sec p-md-5">
        <!--                <full-calendar @event-selected="eventSelected" :config="config" :events="events"></full-calendar>-->
        <div class="row">
          <div class="col-md-6 order-md-2">
            <div class="event-desc-box">
              <h3 class="event-desc__title">
                Листа догађаја за месец
                <span class="monthName">{{ calendarCurrentMonth }}.</span>
                године
              </h3>
              <div v-if="calendarEvents" class="event-list-box">
                <b-alert v-for="(event, index) in calendarEvents" show v-bind:key="event.eventDate"
                  :class="{ 'alert-selected': index === hoveredEvent }">
                  <h5 class="">{{ event.title }}</h5>
                  <p class="small">
                    <b>{{ event.eventDate }} </b>
                  </p>
                  <div>
                    {{ event.description }}
                  </div>
                </b-alert>
              </div>
              <div v-if="eventMessageTitle">
                <b-alert dismissible v-model="alertShow">
                  <h5 class="">{{ eventMessageTitle }}</h5>
                  <p class="small">
                    <b>{{ eventMessageDate }} </b>
                  </p>
                  <div>
                    {{ eventMessageDesc }}
                  </div>
                </b-alert>
              </div>
            </div>
          </div>
          <div class="col-md-6 order-md-1">
            <FullCalendar locale="sr-cyrl" class="demo-app-calendar" ref="fullCalendar" defaultView="dayGridMonth"
              :header="{
                left: 'prev,next',
                center: 'title',
                right: ''
              }" :plugins="calendarPlugins" :weekends="calendarWeekends" :events="calendarEvents"
              @eventClick="eventSelected" @eventRender="eventRender" @eventMouseEnter="eventHovered"
              @datesRender="handleMonthChange" :eventBackgroundColor="eventBackgroundColor" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { FullCalendar } from 'vue-full-calendar';
// import 'fullcalendar/dist/fullcalendar.css';
// import 'fullcalendar/dist/locale/fr'
// import "./popper.js";
// import  "./tooltip.js";
import moment from "moment";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

moment.locale("sr-cyrl");

// import Popper from 'vue-popperjs';
import "vue-popperjs/dist/vue-popper.css";

// must manually include stylesheets for each plugin
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";

import axios from "axios";


export default {
  name: "CalendarPage1",
  data() {
    return {
      alertShow: false,
      monthDate: null,
      baseApiUrl: window.env.VUE_APP_API_FP_DEV,
       
      calendarPlugins: [
        // plugins must be defined in the JS
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin // needed for dateClick
      ],
      eventBackgroundColor: "#395f84",
      calendarWeekends: true,
      calendarEvents: null,

      eventMessage: null,
      eventMessageTitle: null,
      eventMessageDesc: null,
      eventMessageDate: null,

      calendarCurrentMonth: null,
      eventList: null,
      hoveredEvent: null,
      meta: {
        title: "Правно-информациони систем РС",
        description:
          "Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.",
        keywords:
          "zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik"
      }
    };
  },
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        { name: "title", content: this.meta.title },
        { name: "description", content: this.meta.description },
        { name: "keywords", content: this.meta.keywords }
      ]
    };
  },
  components: {
    FullCalendar
    // Popper
  },
  methods: {
    // http://10.10.30.99:8080/SlGlasnikPortal/api/fp/events?date=1576822937462
    // 1576822937462
    // 1576825239416
    // 1576825575332

    eventRender(info) {
      console.log("eventRender: ", info);
      // var tooltip = new Tooltip(info.el, {
      //     title: info.event.extendedProps.description,
      //     placement: 'top',
      //     trigger: 'hover',
      //     container: 'body'
      // });
      // console.log(tooltip);
    },
    eventSelected(info) {
      // this.alertShow = true;
      this.hoveredEvent = info.event.extendedProps.arrIndex;
      // this.eventMessage = info.event.extendedProps.description;

      // this.eventMessageTitle = info.event.title;
      // this.eventMessageDesc = info.event.extendedProps.description;
      // this.eventMessageDate = moment(info.event.start).format("DD MMMM YYYY");
    },
    eventHovered(info) {
      this.hoveredEvent = info.event.extendedProps.arrIndex;
      // this.alertShow = true;
      // this.eventMessage = info.event.extendedProps.description;
    },
    fetchMonthData(date) {
      axios
        .post(this.baseApiUrl + "prins/GetEventsForPrins", {
          "eventDateFrom": moment(date).startOf('month'),
          "eventDateTo": moment(date).endOf('month'),
          "active": 1,
          "published": 1
        })
        .then(response => {
          console.log("response.data: ", response.data);
          let resultArray = response.data.map(function (elm, index) {
            return {
              title: elm["title"],
              start: elm["eventDate"],
              description: elm["description"],
              arrIndex: index
            };
          });

          this.eventList = response.data;
          this.calendarEvents = resultArray;
          console.log("resultArray: ", resultArray);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    handleMonthChange: function (arg) {
      var currentStart = arg.view.currentStart;
      this.calendarCurrentMonth = moment(currentStart).format("MMMM YYYY");
      // this.calendarCurrentMonth = 'test;'
      // gets month data from API
      this.fetchMonthData(moment(currentStart, "x"));
    }
  },
  mounted() {
    this.fetchMonthData(moment(new Date(), "x"));
  }
};
</script>

<style>
.alert-selected {
  background-color: #84999c;
  color: #fff;
}
</style>
